import Api from '../http.service';

/**
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.data._id
 * @param {String} payload.data.fullName
 * @param {String} payload.data.email
 * @param {String} payload.data.message
 * @param {Date} payload.data.registeredDate
 * @param {String} payload.data.reply
 */
export const insert = (payload) =>
  Api.POST({
    url: '/contactus/flight',
    data: payload.data,
  });
